import { createContext, useState, useMemo } from "react";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({
    user: null,
    roles: {},
  });
  const [persist, setPersist] = useState(
    JSON.parse(localStorage.getItem("persist")) || false
  );

  // Utility to check if the user has any of the required roles for a route
  const hasRequiredRole = useMemo(() => {
    // Checks if any role in requiredRoles is set to true in auth.roles
    return (requiredRoles) => {
      return requiredRoles.some((role) => auth.roles[role] === true);
    };
  }, [auth.roles]);

  return (
    <AuthContext.Provider
      value={{
        auth,
        setAuth,
        persist,
        setPersist,
        hasRequiredRole,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
